import React from 'react';
import { connect } from 'react-redux';
import {
	autoGenerateReduxPropsNamingForContentModels,
	generateReduxPropsUpdateActionByContentType,
} from '../../../../../../../services/content-models-service/ContentModelService';
import {
	extractContentModeBasedOnUrl,
	extractMainContentTypeBasedOnUrl,
	isArrayEmpty,
	isObjectEmpty,
} from '../../../../../../../global-helpers/global.helpers';
import { DATA_QA_ATTRIBUTES } from '../../../constants/data-qa.attributes';
import CategoryModel from '../../../../../../../models/v2/category/category.model';
import { ReduxGeneralContentProps } from '../../../constants/redux-general-content.attributes';
import CategoryPicker from '../../../components/CategoryPicker';

type MainCategorySelectProps = {
	t: any;
	categoriesRedux: CategoryModel[];
	adminCategoriesRedux: CategoryModel[];
	selectedCategory: CategoryModel | null;
	updateTempProperty: (propertyObject: Record<string, any>) => void;
};

const MainCategorySelect: React.FC<MainCategorySelectProps> = ({
	t,
	categoriesRedux,
	adminCategoriesRedux,
	selectedCategory,
	updateTempProperty,
}) => {
	const onCategorySelect = (selectedCategory: CategoryModel | CategoryModel[] | null) => {
		const selectedMainCategory = Array.isArray(selectedCategory) ? selectedCategory[0] || null : selectedCategory;

		updateTempProperty({
			[ReduxGeneralContentProps.CATEGORY]: selectedMainCategory,
		});
	};

	if (isArrayEmpty(categoriesRedux)) {
		return null;
	}

	const allCategories = [...categoriesRedux, ...adminCategoriesRedux];

	return (
		<CategoryPicker
			id={DATA_QA_ATTRIBUTES.MAIN_CATEGORY}
			label={t('main_category')}
			categories={allCategories}
			selectedValue={selectedCategory}
			onChange={onCategorySelect}
			placeholder={t('select')}
			isMulti={false}
			disabled={false}
		/>
	);
};

function mapStateToProps(state: any) {
	const { tempPropertyNaming, nestedTempPropertyNaming } = autoGenerateReduxPropsNamingForContentModels();
	const selectedCategory = state[tempPropertyNaming][nestedTempPropertyNaming].category;

	return {
		selectedCategory: !isObjectEmpty(selectedCategory) ? selectedCategory : null,
		categoriesRedux: state.category.allCategories || [],
		adminCategoriesRedux: state.category.adminCategories || [],
	};
}

function mapDispatchToProps(dispatch: Function) {
	const contentTypeFromUrl = extractMainContentTypeBasedOnUrl();
	const functionForDispatch = generateReduxPropsUpdateActionByContentType(contentTypeFromUrl);

	return {
		updateTempProperty: (propertyObject: Record<string, any>) =>
			functionForDispatch && dispatch(functionForDispatch(propertyObject, extractContentModeBasedOnUrl())),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(MainCategorySelect);
